const PREFIX = 'OPEN_PLATFORM_PARTNER_CONSENT_';

export const OPEN_PLATFORM_PARTNER_CONSENT_PAGE_REQUEST = `${PREFIX}PAGE_REQUEST`;

export const OPEN_PLATFORM_PARTNER_CONSENT_REGISTER_MERCHANT_CONSENT = `${PREFIX}REGISTER_MERCHANT_CONSENT`;

export const OPEN_PLATFORM_PARTNER_CONSENT_SET_PARTNER_DETAIL = `${PREFIX}SET_PARTNER_DETAIL`;

export const OPEN_PLATFORM_PARTNER_CONSENT_SET_ACTION_ALLOW = `${PREFIX}SET_ACTION_ALLOW`;

export const OPEN_PLATFORM_PARTNER_CONSENT_SET_ACTION_DENY = `${PREFIX}SET_ACTION_DENY`;

export const OPEN_PLATFORM_PARTNER_CONSENT_SET_ACTION_ERROR = `${PREFIX}SET_ACTION_ERROR`;

export const OPEN_PLATFORM_PARTNER_CONSENT_SET_ERROR_MESSAGE = `${PREFIX}SET_ERROR_MESSAGE`;

export const OPEN_PLATFORM_PARTNER_CONSENT_RESET_ERROR_MESSAGE = `${PREFIX}RESET_ERROR_MESSAGE`;

export const OPEN_PLATFORM_PARTNER_CONSENT_RESET = `${PREFIX}RESET`;
